<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'予約状況' | translate}}</h1>

  <div class="basic-button" fxLayoutGap="10px">
    <button mat-raised-button color="primary" (click)="openSearch()" [disabled]="false">
      <mat-icon>search</mat-icon>
      <span>{{'条件' | translate}}</span>
    </button>

    <button mat-raised-button color="warn" (click)="deleteData()" [disabled]="!selection.selected.length">
      <mat-icon>delete</mat-icon>
      <span>{{'削除' | translate}}</span>
    </button>
  </div>
</div>

<div class="filter-field" fxLayout="row" fxLayoutGap="20px">
  <mat-form-field fxFlex="25%">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
  </mat-form-field>
  <mat-form-field fxFlex="15%">
    <mat-select placeholder="{{'属性' | translate}}" id="reservationFacilityAttributeId" (selectionChange)="applyFilterAttr($event)">
      <mat-option [value]= ""></mat-option>
      <mat-option *ngFor="let reservationFacilityAttribute of reservationFacilityAttributes" [value]="reservationFacilityAttribute.attribute_id">
        {{ reservationFacilityAttribute.attribute_names | multiName:projectLanguages:projectBaseLang }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="center center" [formGroup]="editForm">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef> No. </th>
      <td mat-cell *matCellDef="let reservation; let i = index"> {{searchParameter.index == 0 ?  i + 1 : i + 1 + searchParameter.index * searchParameter.limit }} </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell *matHeaderCellDef> {{'編集' | translate}} </th>
      <td mat-cell *matCellDef="let reservation">
        <button mat-button color="primary" (click)="openEditDialog(reservation)">
          <mat-icon>create</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef> {{'削除' | translate}} </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox color="warn" (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="attribute">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'属性' | translate}} </th>
      <td mat-cell *matCellDef="let reservation">
        <span
          *ngFor="let attribute of (reservation.reservation_facility_attribute_id | docsByCond:attrCollectionName:'attribute_id' | async)">
          {{ attribute.attribute_names | multiName:projectLanguages:projectBaseLang }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="reservation_facility_name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'名称' | translate}} </th>
      <td mat-cell *matCellDef="let reservation">
        <div *ngFor="let reservationFacility of reservationFacilities">
          <div *ngIf="reservation.reservation_facility_id === reservationFacility.reservation_facility_id">
            {{ reservationFacility.reservation_facility_names | multiName:projectLanguages:projectBaseLang }}
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="exhibit_id">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'展示ID' | translate}} </th>
      <td mat-cell *matCellDef="let reservation">
        <div *ngIf="reservation.exhibit_id">
          {{ reservation.exhibit_id }}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="reservation_no">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'予約番号' | translate}} </th>
      <td mat-cell *matCellDef="let reservation"> {{ reservation.reservation_no }} </td>
    </ng-container>

    <ng-container matColumnDef="company_name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'会社名' | translate}} </th>
      <td mat-cell *matCellDef="let reservation"> {{ reservation.company_name }} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'予約者' | translate}} </th>
      <td mat-cell *matCellDef="let reservation"> {{ reservation.family_name }}&nbsp;&nbsp;{{ reservation.first_name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="email_address">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'メールアドレス' | translate}} </th>
      <td mat-cell *matCellDef="let reservation"> {{ reservation.email_address }} </td>
    </ng-container>

    <ng-container matColumnDef="use_start_date">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'利用日' | translate}} </th>
      <td mat-cell *matCellDef="let reservation"> {{ reservation.reservation_start_date.toDate() | date: 'yyyy/MM/dd' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="use_end_date">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'利用日(延泊)' | translate}} </th>
      <td mat-cell *matCellDef="let reservation"><span *ngIf="reservation.reservation_end_date"> {{
          reservation.reservation_end_date.toDate() | date: 'yyyy/MM/dd' }} </span></td>
    </ng-container>

    <ng-container matColumnDef="use_times">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'利用時間' | translate}} </th>
      <td mat-cell *matCellDef="let reservation">
        <div *ngFor="let reservation_time of reservation.reservation_times">{{ reservation_time.item }} </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="reservation_status">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'予約状況' | translate}} </th>
      <td mat-cell *matCellDef="let reservation"> 
        <ng-container *ngIf="reservation.reservation_status === 1">
          <a href="#" (click)="$event.preventDefault(); openConfirmDialog(reservation)">{{ reservation.reservation_status | reservationStatus }}</a>
        </ng-container>
        <ng-container *ngIf="reservation.reservation_status !== 1">
          {{ reservation.reservation_status | reservationStatus }}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="mail_send_status">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'メール送信状況' | translate}} </th>
      <td mat-cell *matCellDef="let reservation"> {{ reservation.mail_send_status | mailSendStatus }}</td>
    </ng-container>

    <ng-container matColumnDef="preview">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'環境' | translate}} </th>
      <td mat-cell *matCellDef="let reservation"> {{ reservation.preview | preview }}</td>
    </ng-container>

    <!-- <ng-container matColumnDef="file">
      <th mat-header-cell *matHeaderCellDef> {{'画像' | translate}} </th>
      <td mat-cell *matCellDef="let reservationFacility">
        <img *ngIf="!!reservationFacility.reservation_facility_files[0]" [src]="(reservationFacility.reservation_facility_files[0].file_id | doc:uploadedFilesCollectionName | async)?.download_url" height="40px" width="auto">
      </td>
    </ng-container> -->

    <ng-container matColumnDef="created">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'登録日時' | translate}} </th>
      <td mat-cell *matCellDef="let reservation"><span *ngIf="reservation.created"> {{ reservation.created.toDate() |
          date: 'yyyy/MM/dd HH:mm:ss' }} </span></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <div fxFlex="67px">
    <div fxLayout="column" fxFlexFill fxLayoutAlign="start stretch">
      <div fxFlex='2px' style="background: #3F51B5;"></div>
      <div fxLayout="row" fxFlexFill fxLayoutAlign="end center">
        <div fxFlex>
          <div fxLayout="column" fxFlexFill fxLayoutAlign="start end" style="font-size: 12px; color: rgba(0,0,0,.54);">
            Items per page:
          </div>
        </div>
        <div fxFlex="10px"></div>
        <div fxFlex="56px" [style.fontSize.px]="12">
          <div fxLayout="column" fxFlexFill fxLayoutAlign="start stretch">
            <mat-form-field style="width: 75px;" appearance="outline" fxFlex>
              <mat-select formControlName="pagesize" (selectionChange)="onPageSizeChange($event)" [disabled]="!!isProcessing">
                <mat-option value=15>15</mat-option>
                <mat-option value=50>50</mat-option>
                <mat-option value=100>100</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div fxFlex="50px"></div>
        <div fxFlex="40px">
          <button mat-icon-button (click)="onPrevClick()" [disabled]="searchParameter.index === 0 || !searchParameter.prev_doc || !!isProcessing"><mat-icon>keyboard_arrow_left</mat-icon></button>
        </div>
        <div fxFlex="40px">
          <button mat-icon-button (click)="onNextClick()" [disabled]="!searchParameter.next_doc || !!isProcessing"><mat-icon>keyboard_arrow_right</mat-icon></button>
        </div>
        <div fxFlex="10px"></div>
      </div>
    </div>
  </div>

</div>
